import EvaluateItemsConfig from './EvaluateItemsConfig';
import ActionScheduleOverview from './ActionScheduleOverview.vue';
import ActionScheduleConfig from './ActionScheduleConfig.vue';
import AIDeepResearchOverview from './AIDeepResearchOverview.vue';
import AIDeepResearchConfig from './AIDeepResearchConfig.vue';
import AIAgentOverview from './AIAgentOverview.vue';
import AIAgentConfig from './AIAgentConfig.vue';
import AITextGenerationOverview from './AITextGenerationOverview.vue';
import AITextGenerationConfig from './AITextGenerationConfig.vue';
import AESDecryptOverview from './AESDecryptOverview.vue';
import AESDecryptConfig from './AESDecryptConfig.vue';
import AESEncryptOverview from './AESEncryptOverview.vue';
import AESEncryptConfig from './AESEncryptConfig.vue';
import ActionApiOverview from './ActionApiOverview';
import ActionApiConfig from './ActionApiConfig.vue';
import ChartOverview from './ChartOverview.vue';
import ChartConfig from './ChartConfig.vue';
import ConditionOverview from './ConditionOverview.vue';
import ConditionConfig from './ConditionConfig.vue';
import DataAnalysisOverview from './DataAnalysisOverview.vue';
import DataAnalysisConfig from './DataAnalysisConfig.vue';
import DataAdapterOverview from './DataAdapterOverview.vue';
import DataAdapterConfig from './DataAdapterConfig.vue';
import DataTransformOverview from './DataTransformOverview.vue';
import DataTransformConfig from './DataTransformConfig.vue';
import DocumentHTMLOverview from './DocumentHTMLOverview.vue';
import DocumentHTMLConfig from './DocumentHTMLConfig.vue';
import DocumentImageOverview from './DocumentImageOverview.vue';
import DocumentImageConfig from './DocumentImageConfig.vue';
import DocumentPDFOverview from './DocumentPDFOverview.vue';
import DocumentPDFConfig from './DocumentPDFConfig.vue';
import ActionEmailOverview from './ActionEmailOverview.vue';
import ActionEmailConfig from './ActionEmailConfig.vue';
import FlowInvokeOverview from './FlowInvokeOverview.vue';
import FlowInvokeConfig from './FlowInvokeConfig.vue';
import JWTDecodeOverview from './JWTDecodeOverview.vue';
import JWTDecodeConfig from './JWTDecodeConfig.vue';
import JWTIsExpiredOverview from './JWTIsExpiredOverview.vue';
import JWTIsExpiredConfig from './JWTIsExpiredConfig.vue';
import JWTSignOverview from './JWTSignOverview.vue';
import JWTSignConfig from './JWTSignConfig.vue';
import JWTVerifyOverview from './JWTVerifyOverview.vue';
import JWTVerifyConfig from './JWTVerifyConfig.vue';
import ResponseOverview from './ResponseOverview.vue';
import ResponseConfig from './ResponseConfig.vue';
import StatementOverview from './StatementOverview.vue';
import StatementConfig from './StatementConfig.vue';
import ParallelOverview from './ParallelOverview.vue';
import ParallelConfig from './ParallelConfig.vue';
import TextGenerationOverview from './TextGenerationOverview.vue';
import TextGenerationConfig from './TextGenerationConfig.vue';
import TransitionOverview from './TransitionOverview.vue';
import TransitionConfig from './TransitionConfig.vue';
import DataMapperDataTableToExcelOverview from './DataMapperDataTableToExcelOverview.vue';
import DataMapperDataTableToExcelConfig from './DataMapperDataTableToExcelConfig.vue';
import DataMapperExcelToDataTableOverview from './DataMapperExcelToDataTableOverview.vue';
import DataMapperExcelToDataTableConfig from './DataMapperExcelToDataTableConfig.vue';
import DataExportOverview from './DataExportOverview.vue';
import DataExportConfig from './DataExportConfig.vue';

export const Categories = [
  { key: 'ai', icon: 'psychology', color: 'text-purple-500' },
  { key: 'logic', icon: 'settings_ethernet', color: 'text-green-500' },
  { key: 'crypto', icon: 'encrypted', color: 'text-yellow-600' },
  { key: 'data', icon: 'dataset', color: 'text-blue-500' },
  { key: 'document', icon: 'docs', color: 'text-indigo-400' },
  { key: 'response', icon: 'chat', color: 'text-indigo-700' },
  { key: 'action', icon: 'double_arrow', color: 'text-pink-700' },
];

export default {
  'ai-agent': {
    key: 'ai-agent',
    icon: 'memory',
    category: 'ai',
    component: AIAgentOverview,
    configComponent: AIAgentConfig,
    config: EvaluateItemsConfig['ai-agent'],
  },
  'ai-text-gen': {
    key: 'ai-text-gen',
    icon: 'network_intel_node',
    category: 'ai',
    component: AITextGenerationOverview,
    configComponent: AITextGenerationConfig,
    config: EvaluateItemsConfig['ai-text-gen'],
  },
  'ai-deepresearch': {
    key: 'ai-deepresearch',
    icon: 'network_intel_node',
    category: 'ai',
    component: AIDeepResearchOverview,
    configComponent: AIDeepResearchConfig,
    config: EvaluateItemsConfig['ai-deepresearch'],
  },
  'ai-text-generation': {
    key: 'ai-text-generation',
    icon: 'category',
    category: 'ai',
    component: TextGenerationOverview,
    configComponent: TextGenerationConfig,
    config: EvaluateItemsConfig['ai-text-generation'],
  },
  'logic-condition': {
    key: 'logic-condition',
    icon: 'code',
    category: 'logic',
    component: ConditionOverview,
    configComponent: ConditionConfig,
    config: EvaluateItemsConfig['logic-condition'],
  },
  'logic-parallel': {
    key: 'logic-parallel',
    icon: 'route',
    category: 'logic',
    component: ParallelOverview,
    configComponent: ParallelConfig,
    config: EvaluateItemsConfig['logic-parallel'],
  },
  'logic-statement': {
    key: 'logic-statement',
    icon: 'variable',
    iconColor: 'text-blue-500',
    category: 'logic',
    component: StatementOverview,
    configComponent: StatementConfig,
    config: EvaluateItemsConfig['logic-statement'],
  },
  'logic-transition': {
    key: 'logic-transition',
    icon: 'transition_right',
    category: 'logic',
    component: TransitionOverview,
    configComponent: TransitionConfig,
    config: EvaluateItemsConfig['logic-transition'],
  },
  'data-analysis': {
    key: 'data-analysis',
    icon: 'database_search',
    category: 'data',
    component: DataAnalysisOverview,
    configComponent: DataAnalysisConfig,
    config: EvaluateItemsConfig['data-analysis'],
  },
  // 'data-connector': {
  //   key: 'data-adapter',
  //   icon: 'hub',
  //   category: 'data',
  //   component: DataAdapterOverview,
  //   configComponent: DataAdapterConfig,
  //   config: EvaluateItemsConfig['data-adapter'],
  // },
  'data-adapter': {
    key: 'data-adapter',
    icon: 'hub',
    category: 'data',
    component: DataAdapterOverview,
    configComponent: DataAdapterConfig,
    config: EvaluateItemsConfig['data-adapter'],
  },
  'data-transform': {
    key: 'data-transform',
    icon: 'convert_to_text',
    category: 'data',
    component: DataTransformOverview,
    configComponent: DataTransformConfig,
    config: EvaluateItemsConfig['data-transform'],
  },
  'data-chart': {
    key: 'data-chart',
    icon: 'auto_graph',
    category: 'data',
    component: ChartOverview,
    configComponent: ChartConfig,
    config: EvaluateItemsConfig['data-chart'],
  },
  'data-mapper-datatable-to-excel': {
    key: 'data-mapper-datatable-to-excel',
    icon: 'table_convert',
    category: 'data',
    component: DataMapperDataTableToExcelOverview,
    configComponent: DataMapperDataTableToExcelConfig,
    config: EvaluateItemsConfig['data-mapper-datatable-to-excel'],
  },
  'data-mapper-excel-to-datatable': {
    key: 'data-mapper-excel-to-datatable',
    icon: 'table_convert',
    category: 'data',
    component: DataMapperExcelToDataTableOverview,
    configComponent: DataMapperExcelToDataTableConfig,
    config: EvaluateItemsConfig['data-mapper-excel-to-datatable'],
  },
  'data-export': {
    key: 'data-export',
    icon: 'upload',
    category: 'data',
    component: DataExportOverview,
    configComponent: DataExportConfig,
    config: EvaluateItemsConfig['data-export'],
  },
  'document-image': {
    key: 'document-image',
    icon: 'photo',
    category: 'document',
    component: DocumentImageOverview,
    configComponent: DocumentImageConfig,
    config: EvaluateItemsConfig['document-image'],
  },
  'document-html': {
    key: 'document-html',
    icon: 'code_blocks',
    category: 'document',
    component: DocumentHTMLOverview,
    configComponent: DocumentHTMLConfig,
    config: EvaluateItemsConfig['document-html'],
  },
  'document-pdf': {
    key: 'document-pdf',
    icon: 'picture_as_pdf',
    category: 'document',
    component: DocumentPDFOverview,
    configComponent: DocumentPDFConfig,
    config: EvaluateItemsConfig['document-pdf'],
  },
  'response-card': {
    key: 'response-card',
    icon: 'insert_chart',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-card'],
  },
  'response-excel': {
    key: 'response-excel',
    icon: 'table_view_flipped',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-excel'],
  },
  'response-html': {
    key: 'response-html',
    icon: 'code_blocks',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-html'],
  },
  'response-image': {
    key: 'response-image',
    icon: 'photo',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-image'],
  },
  'response-json': {
    key: 'response-json',
    icon: 'data_object',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-json'],
  },
  'response-pdf': {
    key: 'response-pdf',
    icon: 'picture_as_pdf',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-pdf'],
  },
  'response-text': {
    key: 'response-text',
    icon: 'chat',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-text'],
  },
  'response-xml': {
    key: 'response-xml',
    icon: 'xml',
    category: 'response',
    component: ResponseOverview,
    configComponent: ResponseConfig,
    config: EvaluateItemsConfig['response-xml'],
  },
  'crypto-aes-decrypt': {
    key: 'crypto-aes-decrypt',
    icon: 'encrypted',
    category: 'crypto',
    component: AESDecryptOverview,
    configComponent: AESDecryptConfig,
    config: EvaluateItemsConfig['crypto-aes-decrypt'],
  },
  'crypto-aes-encrypt': {
    key: 'crypto-aes-encrypt',
    icon: 'encrypted',
    category: 'crypto',
    component: AESEncryptOverview,
    configComponent: AESEncryptConfig,
    config: EvaluateItemsConfig['crypto-aes-encrypt'],
  },
  'crypto-jwt-decode': {
    key: 'crypto-jwt-decode',
    icon: 'encrypted',
    category: 'crypto',
    component: JWTDecodeOverview,
    configComponent: JWTDecodeConfig,
    config: EvaluateItemsConfig['crypto-jwt-decode'],
  },
  'crypto-jwt-isexpired': {
    key: 'crypto-jwt-isexpired',
    icon: 'encrypted',
    category: 'crypto',
    component: JWTIsExpiredOverview,
    configComponent: JWTIsExpiredConfig,
    config: EvaluateItemsConfig['crypto-jwt-isexpired'],
  },
  'crypto-jwt-sign': {
    key: 'crypto-jwt-sign',
    icon: 'encrypted',
    category: 'crypto',
    component: JWTSignOverview,
    configComponent: JWTSignConfig,
    config: EvaluateItemsConfig['crypto-jwt-sign'],
  },
  'crypto-jwt-verify': {
    key: 'crypto-jwt-verify',
    icon: 'encrypted',
    category: 'crypto',
    component: JWTVerifyOverview,
    configComponent: JWTVerifyConfig,
    config: EvaluateItemsConfig['crypto-jwt-verify'],
  },
  'action-execute-api': {
    key: 'action-execute-api',
    icon: 'api',
    category: 'action',
    component: ActionApiOverview,
    configComponent: ActionApiConfig,
    config: EvaluateItemsConfig['action-execute-api'],
  },
  'action-send-email': {
    key: 'action-send-email',
    icon: 'email',
    category: 'action',
    component: ActionEmailOverview,
    configComponent: ActionEmailConfig,
    config: EvaluateItemsConfig['action-send-email'],
  },
  'action-schedule': {
    key: 'action-schedule',
    icon: 'schedule',
    category: 'action',
    component: ActionScheduleOverview,
    configComponent: ActionScheduleConfig,
    config: EvaluateItemsConfig['action-schedule'],
  },
  'action-invoke-flow': {
    key: 'action-invoke-flow',
    icon: 'account_tree',
    category: 'action',
    component: FlowInvokeOverview,
    configComponent: FlowInvokeConfig,
    config: EvaluateItemsConfig['action-invoke-flow'],
  },
};
